import { Component, OnInit } from '@angular/core';
import { Router,NavigationEnd } from '@angular/router';
import { IntegrationService } from './integration.service';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'Subscrybe';
  showNav = true;
  showLinks = false;
  username = '';
  userid = '';
  currUrl = ''

  constructor(private router:Router,private _integrationService:IntegrationService) {
    this._integrationService.showNav$.subscribe((data) => {
      this.showNav = data; // And he have data here too!
  })
  this._integrationService.userName$.subscribe((data)=>{this.username = data.split(' ')[0]})
  this._integrationService.userId$.subscribe((data)=>{this.userid=data})
  this.router.events.subscribe(event => {
    if(event instanceof NavigationEnd){
        gtag('config', 'UA-160616542-1', 
              {
                'page_path': event.urlAfterRedirects
              }
             );
     }
  }
)
   }
  ngOnInit(){
    this._integrationService.getUser();
  }

  getChevronClass(){
    return this.showLinks ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
  }

  expandLinks(){
    this.showLinks = !this.showLinks;
  }
  isDashboard(){
    if(window.location.href.includes('dashboard')){
      return true;
    }
    return false;
    
  }
}
